module.exports = __webpack_public_path__ + "img/new_coupon_global_banner_bg.4e0dc687.png";